'use strict';

angular.module('pulianiBookStoreApp')
  .controller('MainController', function ($state, $rootScope, $scope, main, productCategory, Auth,toaster) {

    if($state.params.isAuthorised == false){
    	$scope.$emit('onUnathorised',{});
    	toaster.pop('warning','You have logged out, please login to continue');
        $scope.open('lg','login');
    }


	$scope.jsonbody = {
	"limit": 45 ,
	"offset":0,
	"sortBy":{
		"attribute":"created_at",
		"direction":"DESC"
	}
	};
	
	$scope.BestSellerJson= {
    "limit":45,
    "offset":0
    }
	
   var slides_to_show_scroll = (($(window).width())>1200)?5:(($(window).width())>900)?4:(($(window).width())>600)?3:2;
	$scope.slickConfig = {
    enabled: true,
    autoplay: true,
    draggable: false,
    slidesToShow:slides_to_show_scroll,
    slidesToScroll:slides_to_show_scroll,
    autoplaySpeed: 7000
    };
	
	$scope.IMGslickConfig = {
    enabled: true,
    autoplay: true,
    draggable: true,  
	autoplaySpeed: 1000,
	event: {
        beforeChange: function (event, slick, currentSlide, nextSlide) {
        },
        afterChange: function (event, slick, currentSlide, nextSlide) {
        }
    }
    };
	
   
	$scope.isactive = 'tab1';
	$scope.onTabClick = function(tab)
	{
	  $scope.isactive = tab;
	  getProducts();
	}
    
    

	
	function getProducts()
	{
		console.log($scope.isactive);
		$scope.viewLoaded = false;
		if($scope.isactive == 'tab1')
		{
			productCategory.getProducts($scope.jsonbody).then(function(data){
			$scope.Books = data.data;
			// $scope.Books = productCategory.modify_thumbnail_url($scope.Books)
			
			$scope.viewLoaded = true;
			console.log($scope.Books);
			});
		}
		else if($scope.isactive == 'tab2')
		{
			productCategory.getBestSellers($scope.BestSellerJson).then(function(data){
			var bsetSeller_product_list = removeOutOfStockProduct(data.data);
			$scope.Books = bsetSeller_product_list;
			$scope.viewLoaded = true;
			console.log($scope.Books);
			});
		}
	}
	
	function removeOutOfStockProduct(array){
	  let new_product_array = array;
	  for(let i=0; i<array.length; i++){
        if(array[i]['units_in_stock'] === 0){
			new_product_array.splice(i,1);
		}
	  }
	  return new_product_array;
	}
    getProducts();
    
    
    function getBannerImages()
    {
        main.getBannerImages().then(function(data){
           // alert(JSON.stringify(data));
		   $scope.slides = data.data;
			});
    }
    
    getBannerImages();
    
    
    function getNews()
    {
        main.getNews().then(function(data){
          // alert(JSON.stringify(data));
		   $scope.testimonals = data.data;
			});  
    }
    
    getNews();
	
  });
